import { getStoryblokApiInstance as t } from "./state.mjs";
const e = () => {
  const o = t();
  return o || console.error(
    "You can't use getStoryblokApi if you're not loading apiPlugin."
  ), o;
};
export {
  e as getStoryblokApi,
  e as useStoryblokApi
};
